import { render, staticRenderFns } from "./ChangeItemFinish.vue?vue&type=template&id=6bf2dd25&scoped=true&"
import script from "./ChangeItemFinish.vue?vue&type=script&lang=js&"
export * from "./ChangeItemFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2dd25",
  null
  
)

export default component.exports